export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.woff2?3ceb50e7bcafb577367c21b53064e00c";